@if(loading) {
  <div class="bg-black/50 flex justify-center items-center fixed inset-0 z-40">
    <app-loader [message]="'Buscando'"></app-loader>
  </div>
}

<div class="px-6 w-full space-y-5 mt-3">
  <div class="bg-white dark:bg-crayola-blue-800 rounded-xl shadow-sm p-5">
    <div class="space-y-3">
      <div>
        <label class="text-xs font-medium text-vivid-royal-600 dark:text-vivid-royal-200 mb-1 block">Fechas</label>
        <app-datepicker (updateDates)="setDatesOnFilter($event)" [selectedFilterRange]="1"></app-datepicker>
      </div>
      <div class="flex justify-end">
        <button pButton label="Buscar" icon="pi pi-search" class="p-button-sm w-full sm:w-auto" (click)="getStatement()"></button>
      </div>
    </div>
  </div>

  @if(invoices) {
    <app-custom-table [headers]="headers" [elements]="invoices" [actions]="tblButtons"
      [hasButton]="true" [hasFilter]="true"></app-custom-table>
  }
</div>
